import * as React from 'react';
import { TPAComponentProps } from '../../types';

export enum MediaLabelSize {
  large = 'large',
  small = 'small',
}

export interface MediaLabelProps extends TPAComponentProps {
  text?: string;
  icon?: React.ReactNode;
  /** Size can be small or large - affects the padding and margin  */
  size?: string;
}

export interface MediaLabelDefaultProps {
  size?: string;
}
